import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
    selector: "app-faud-engine-add-rule",
    templateUrl: "./faud-engine-add-rule.component.html",
    styleUrls: ["./faud-engine-add-rule.component.scss"],
    standalone: false
})
export class FaudEngineAddRuleComponent implements OnInit {
  form: FormGroup = new FormGroup({
    ruleId: new FormControl("892345675"),
    type: new FormControl(""),
    condition: new FormControl(null),
    remarks: new FormControl(null),
    sMS: new FormControl(false),
    email: new FormControl(false),
    action: new FormControl(""),
  });

  constructor() {}

  get ruleId() {
    return this.form.get("ruleId");
  }

  get condition() {
    return this.form.get("condition");
  }

  get remarks() {
    return this.form.get("remarks");
  }

  onCancel(): void {}

  onSave(): void {}
  ngOnInit(): void {}
}
